module.exports = __webpack_public_path__ + "static/insert_date_2-1f5cd9cdc6d3ee5399c7056b4a467140.png";